angular.module('leanlaw').controller('AttorneyBillableDetailCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', "alerts", 'userService', 'reportsService', 'commonFilterService', "exportJson", "singleRequest", "leanLawApi", "messageBus", "clientMatterManager", function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts, userService, reportsService, commonFilterService, exportJson, singleRequest, leanLawApi, messageBus, clientMatterManager) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = ['client.label', 'matter.label'];
  $scope.reverse = false;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filteredClients.reduce((accum, c) => {
      if ($scope.clientReferences || $scope.references) {
        if ($scope.filter.include && $scope.filter.include.matters) {
          const item = {
            "ID": c.client.reference || "",
            "Client": c.client.name,
            "Hourly": $filter("amount")(c.data.amounts.hours),
            "Fixed Fees": $filter("amount")(c.data.amounts.charges)
          };
          if ($scope.me.company.usesContingency) {
            item["Contingency"] = $filter("amount")(c.data.amounts.contingency);
          }
          item["Total"] = $filter("amount")(c.data.amounts.total);
          item["Expenses"] = $filter("amount")(c.data.amounts.expenses);
          accum.push(item);
        } else {
          const item = {
            "ID": c.client.reference || "",
            "Client": c.client.name,
            "Hourly": $filter("amount")(c.data.amounts.hours),
            "Fixed Fees": $filter("amount")(c.data.amounts.charges)
          };
          if ($scope.me.company.usesContingency) {
            item["Contingency"] = $filter("amount")(c.data.amounts.contingency);
          }
          item["Total"] = $filter("amount")(c.data.amounts.total);
          item["Expenses"] = $filter("amount")(c.data.amounts.expenses);
          accum.push(item);
        }
      } else if ($scope.filter.include && $scope.filter.include.matters) {
        const item = {
          "ID": c.client.reference || "",
          "Client": c.client.name,
          [matter]: "",
          "Hourly": $filter("amount")(c.data.amounts.hours),
          "Fixed Fees": $filter("amount")(c.data.amounts.charges)
        };
        if ($scope.me.company.usesContingency) {
          item["Contingency"] = $filter("amount")(c.data.amounts.contingency);
        }
        item["Total"] = $filter("amount")(c.data.amounts.total);
        item["Expenses"] = $filter("amount")(c.data.amounts.expenses);
        accum.push(item);
      } else {
        const item = {
          "Client": c.client.name,
          "Hourly": $filter("amount")(c.data.amounts.hours),
          "Fixed Fees": $filter("amount")(c.data.amounts.charges)
        };
        if ($scope.me.company.usesContingency) {
          item["Contingency"] = $filter("amount")(c.data.amounts.contingency);
        }
        item["Total"] = $filter("amount")(c.data.amounts.total);
        item["Expenses"] = $filter("amount")(c.data.amounts.expenses);
        accum.push(item);
      }
      if ($scope.filter.include && $scope.filter.include.matters) {
        c.matters.forEach(m => {
          if ($scope.clientReferences || $scope.references) {
            const item = {
              "ID": c.client.reference || "",
              "Client": c.client.name,
              [matter]: m.matter.name,
              "Hourly": $filter("amount")(m.data.amounts.hours),
              "Fixed Fees": $filter("amount")(m.data.amounts.charges)
            };
            if ($scope.me.company.usesContingency) {
              item["Contingency"] = $filter("amount")(m.data.amounts.contingency);
            }
            item["Total"] = $filter("amount")(m.data.amounts.total);
            item["Expenses"] = $filter("amount")(m.data.amounts.expenses);
            accum.push(item);
          } else {
            const item = {
              "Client": c.client.name,
              [matter]: m.matter.name,
              "Hourly": $filter("amount")(m.data.amounts.hours),
              "Fixed Fees": $filter("amount")(m.data.amounts.charges)
            };
            if ($scope.me.company.usesContingency) {
              item["Contingency"] = $filter("amount")(m.data.amounts.contingency);
            }
            item["Total"] = $filter("amount")(m.data.amounts.total);
            item["Expenses"] = $filter("amount")(m.data.amounts.expenses);
            accum.push(item);
          }
        });
      }
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.return = function () {
    $state.go('reports.attorney-billable');
  };
  activate();

  /////////////////////////////

  async function activate() {
    $scope.me = await userService.me();
    if ($stateParams.userId) {
      $scope.user = await leanLawApi.getAccount({
        id: $stateParams.userId
      });
    }
    $scope.$on('commonFilterService-statechanged', (event, payload) => {
      if (!payload) return;
      // Assigning to existing filter keeps custom filter options
      $scope.filter = Object.assign($scope.filter, payload);
      // Necessary to set this value for the requests
      $scope.filter.status = $scope.filter.archived.status;
      $scope.filter.billedState = $scope.filter.billedFilter && $scope.filter.billedFilter.id;
      filterClientEntries();
    });
    $scope.$on("report-sidebar-filterchange", (event, payload) => {
      $scope.filter = Object.assign($scope.filter, payload);
    });
    $scope.$watch('filter.include.accounting', show => {
      if (show) {
        filterClientEntries();
      }
    }, true);

    // MessageBus is used here so that the commonFilter module can pick it up once it loads
    messageBus.addMessage("filterDependency-ready", true);
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("report");
    singleRequest.cancel("report2");
    deactivate();
  });
  function filterClientEntries() {
    const query = reportsService.queryFromFilter($scope.filter);
    query.data = "services,expenses,charges";
    query.primary = 'clients';
    query.account = $scope.user ? $scope.user.id : "none";
    query.reportType = 'billable';
    $scope.loading = true;
    const requests = [singleRequest.serviceCall("report", reportsService.getReport)(query)];
    if ($scope.me.company.usesContingency) {
      query.data = "cost";
      query.billingType = "contingency";
      requests.push(singleRequest.serviceCall("report2", reportsService.getReport)(query));
    }
    $q.all(requests).then(([data, contingency]) => {
      if (!data) return; // happens if we were canceled
      $scope.data = data;
      if (contingency) {
        // merge contingency data in with other data
        contingency.clients.forEach(client => {
          const amount = client.data.hours.nonBillableCost;
          let existingClient = data.clients.find(u => u.client.id === client.client.id);
          if (amount) {
            if (!existingClient) {
              existingClient = client;
              client.data.amounts = {};
              data.clients.push(existingClient);
            }
            existingClient.data.amounts.contingency = amount;
          }
          client.matters.forEach(matter => {
            const matterAmount = matter.data.hours.nonBillableCost;
            if (amount) {
              let existingMatter = existingClient.matters.find(u => u.matter.id === matter.matter.id);
              if (!existingMatter) {
                existingMatter = matter;
                matter.data.amounts = {};
                client.matters.push(existingMatter);
              }
              existingMatter.data.amounts.contingency = matterAmount;
            }
          });
        });
        data.data.amounts.contingency = contingency.data.hours.nonBillableCost;
        data.data.amounts.total = data.data.amounts.contingency + data.data.amounts.hours + data.data.amounts.charges;
      }
      $scope.loading = false;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredClients = $filter('orderBy')($filter('filter')($scope.data.clients, $scope.search), $scope.sort, $scope.reverse) || [];
    $scope.data.filteredClients.forEach(client => {
      client.filteredMatters = $filter('orderBy')($filter('filter')(client.matters, $scope.q), $scope.sort, $scope.reverse) || [];
    });
  }
  $scope.$watch('data.clients', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);